import * as tslib_1 from "tslib";
import React from 'react';
import PropTypes from 'prop-types';
import { StyledTh, StyledTd } from './TableElement';
/**@ReactComponent
 *
 * 表格中的列
 */
var TableCell = function (props, context) {
    var _a = props.padding, padding = _a === void 0 ? 'default' : _a, _b = props.numeric, numeric = _b === void 0 ? false : _b, children = props.children, other = tslib_1.__rest(props, ["padding", "numeric", "children"]);
    var Comp = context.table && (context.table.head || context.table.footer)
        ? StyledTh
        : StyledTd;
    return React.createElement(Comp, { padding: padding, numeric: numeric, children: props.children });
};
TableCell.contextTypes = {
    table: PropTypes.object,
};
export default TableCell;
//# sourceMappingURL=TableCell.js.map